import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type RowProps = {
  gap: number;
  align: "start" | "center" | "end" | "stretch";
  justify: "start" | "center" | "end" | "between";
  wrap: boolean;
  style?: ResponsiveStyleProps;
};

export function RowBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<RowProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Gap ({props.gap ?? 24}px)</Label>
          <Slider
            value={[props.gap ?? 24]}
            max={64}
            step={4}
            onValueChange={([v]) => setProp((p) => { p.gap = v; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Align items</Label>
          <Select
            value={props.align ?? "stretch"}
            onValueChange={(v) => setProp((p) => { p.align = v as RowProps["align"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="start">Start</SelectItem>
              <SelectItem value="center">Center</SelectItem>
              <SelectItem value="end">End</SelectItem>
              <SelectItem value="stretch">Stretch</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Justify</Label>
          <Select
            value={props.justify ?? "start"}
            onValueChange={(v) => setProp((p) => { p.justify = v as RowProps["justify"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="start">Start</SelectItem>
              <SelectItem value="center">Center</SelectItem>
              <SelectItem value="end">End</SelectItem>
              <SelectItem value="between">Space between</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center justify-between">
          <Label className="text-xs">Wrap columns</Label>
          <Switch
            checked={props.wrap !== false}
            onCheckedChange={(v) => setProp((p) => { p.wrap = v; })}
          />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
